var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-loading',{attrs:{"type":"bars","color":"#F87653","size":{ width: '50px', height: '50px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }